import Banner from '../components/home/Banner'
import HeroSlider from '../components/home/HeroSlider'
import Philosophy from '../components/home/Philosophy'
import PartnerSlider from '../components/home/PartnerSlider'
import Cards from '../components/home/Cards'
import Stats from '../components/home/Stats'
import Footer from '../components/home/footer/Footer'

// Swiper stilleri
import 'swiper/css';
import 'swiper/css/navigation';
import Services from '../components/home/Services'


const Home = () => {
    return (
        <div className="overflow-hidden font-iransansRegular">
            <Banner />
            <HeroSlider />
            <Philosophy />
            <PartnerSlider />
            <Services />
            <Cards />
            <Stats />
            <Footer />
        </div>
    );
};

export default Home;